import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useFilterValue, useWillOnlyConstrain } from '@morningtrain/react-filters'
import { ButtonTabs } from 'ui/buttons'
import { FieldWrapper, useFieldOptions } from '@morningtrain/react-fields'
import * as UI from 'ui'
import {Translation, useTranslation} from "@morningtrain/react-translations";

function SwitchFilter (props) {
  const {
    name,
    defaultValue,
    onChange = () => {},
    allowNull = false,
    iconMap = null,
    isFrontTranslated = false,
    translationKey = null
  } = props

  const [value, setValue] = useFilterValue(name, defaultValue)

  React.useEffect(() => {
    if (typeof defaultValue !== 'undefined') {
      setValue(defaultValue)
    }
  }, [])

  useWillOnlyConstrain(name, value)

  const options = useFieldOptions(props)

  const handleChange = (newValue) => {
    if (newValue === value && allowNull) {
      newValue = null
    }

    onChange(newValue)
    setValue(newValue)
  }

  const translatedOptionValue = function(value) {
    return useTranslation(translationKey + '.' + value)
  }

  return (
    <FieldWrapper label={props.label} className='w-auto'>
      <ButtonTabs classNames={props.className} size={props.size} fullWidth={props.fullWidth}>
        {props.placeholder && (
          <button
            type='button'
            className={(!value) ? 'active' : 'inactive'}
            onClick={() => handleChange(null)}
          >
            <span className='flex items-center justify-center'>
              {props.placeholder}
            </span>
          </button>
        )}
        {options.map(option => (
          <button
            key={option.value}
            type='button'
            className={(option.value === value) ? 'active' : 'inactive'}
            onClick={() => handleChange(option.value)}
          >
            <span className='flex items-center justify-center'>
              {iconMap && !!iconMap[option.value]
                ? (
                  <UI.WithIcon icon={iconMap[option.value]}>
                    <UI.Text block className='mt-0.5'>
                      {option.label}
                    </UI.Text>
                  </UI.WithIcon>
                  )
                : isFrontTranslated
                  ? translatedOptionValue(option.value)
                  : option.label}
            </span>
          </button>
        ))}
      </ButtonTabs>
    </FieldWrapper>
  )
}

SwitchFilter.defaultProps = {
  label: null,
  only: null,
  iconMap: null
}

SwitchFilter.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  enum: PropTypes.string.isRequired,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  only: PropTypes.array,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  iconMap: PropTypes.object
}

export default observer(SwitchFilter)
